import React from "react";
import styled from "styled-components";

export default styled.input`
    font-size: 16px;
    line-height: 20px;
    color: #6A6D90;
    width: 276px;
    height: 38px;
    text-align: center;
    display: block;
    margin: 0 auto 20px;
    border: 1px solid #979797;
    box-sizing: border-box;
`;